module.exports = __webpack_public_path__ + "img/Icon - Add Photo.f8f2d830.svg";